/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipFileApprovalStatusOptionViewModel } from "../types/ScholarshipFileApprovalStatusOptionViewModel.ts";
import { eScholarshipTypeStudentFileApprovalStatusSchema } from "./eScholarshipTypeStudentFileApprovalStatusSchema.ts";

export const scholarshipFileApprovalStatusOptionViewModelSchema = z.object({
  status: z.optional(
    z
      .lazy(() => eScholarshipTypeStudentFileApprovalStatusSchema)
      .describe(
        "0 = PendingAnswerFromTeam | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
      ),
  ),
  description: z
    .string()
    .describe(
      "Descrição do status, localizada pela cultura informada na requisição.",
    )
    .nullish(),
  isCurrent: z.optional(
    z
      .boolean()
      .describe(
        "Indica se é o status geral atual do aluno. Exatamente uma opção vem marcada.",
      ),
  ),
}) as unknown as ToZod<ScholarshipFileApprovalStatusOptionViewModel>;
